<p>store-apps-tab works!</p>
